import "../../styles/Faq/faq.css";
import { useState } from "react";
import Banner from "../home/registrationCard";
const FAQSection = () => {
  // State to track which question is currently open (null = all closed)
  const [activeId, setActiveId] = useState(null);

  // Toggle function: if clicked ID is already open, close it (set null), else open it
  const toggleFAQ = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  const faqData = [
    {
      id: 1,
      question: "What is Madhi Academy?",
      answer:
        "Madhi Academy is a Chennai-based learning hub offering complete education support — from school tuition (1st to 12th) to professional courses (CA, CMA, CS, CPA, CMA US, EA), commerce degrees, and job-ready skill training.",
    },
    {
      id: 2,
      question: "Which courses can I join at Madhi Academy?",
      // USE THIS FORMAT FOR THE LIST STYLE IN YOUR IMAGE:
      answer: (
        <div>
          <p className="mb-3">We provide:</p>
          <ul className="list-unstyled ps-2">
            {" "}
            {/* list-unstyled removes default bullets, we add custom ones or standard */}
            <li className="mb-2">
              • <strong>School Programs</strong> – CBSE & State Board
              (1st–12th).
            </li>
            <li className="mb-2">
              • <strong>Indian Professional Courses</strong> – CA, CMA, CS.
            </li>
            <li className="mb-2">
              • <strong>Global Certifications</strong> – US CPA, US CMA, EA.
            </li>
            <li className="mb-2">
              • <strong>Commerce Degrees</strong> – B.Com, BBA, B.Sc (CS) with
              professional add-ons.
            </li>
            <li className="mb-2">
              • <strong>Skills Training</strong> – ERP, Computer Basics, English
              Communication.
            </li>
          </ul>
        </div>
      ),
    },
    {
      id: 3,
      question: "Do you offer online classes?",
      answer:
        "Yes. Students can attend recorded classes with live Q&A sessions. Online support is available for school tuition, professional courses, and skill training.",
    },
    {
      id: 4,
      question: "What is the teaching method followed?",
      answer: (
        <div>
          <p className="mb-3">Our approach combines:</p>
          <ul className="list-unstyled ps-2">
            <li className="mb-3">• Daily tuition & small group sessions.</li>
            <li className="mb-3">• Recorded + live interactive classes.</li>
            <li className="mb-3">• Printed/digital notes.</li>
            <li className="mb-3">
              • Test series, mock exams, and revision camps.
            </li>
            <li className="mb-3">• One-on-one doubt clearing.</li>
          </ul>
        </div>
      ),
    },
    {
      id: 5,
      question: "How do I know which course is right for me?",
      answer:
        "Our academic counselors guide each student based on their background, career goals, and eligibility. You can contact us for a free consultation.",
    },
    {
      id: 6,
      question: "What is the fee structure?",
      answer:
        " Fees vary depending on the course. We offer affordable plans with installment options across all programs.",
    },
    {
      id: 7,
      question: "Do you provide placement support?",
      answer:
        "Yes. Madhi Academy students have been placed in Big 4 firms, MNCs, and leading corporates. We also provide career counselling, industry networking, and placement assistance for degree and global programs.",
    },
    {
      id: 8,
      question: "Are admissions open year-round?",
      answer:
        "Yes. Admissions are open throughout the year. Recorded classes allow you to start anytime, and live sessions run in batches.",
    },
    {
      id: 9,
      question: "What is the success rate of Madhi Academy students?",
      answer:
        "We have 12+ years of teaching excellence, with 2,000+ students trained in India and abroad, and a 90%+ pass rate in key professional courses.",
    },
    {
      id: 10,
      question: "How do I apply for admission?",
      answer: (
        <p>
          Anyone interested can apply. Please visit{" "}
          <a
            href="https://www.madhiacademy.com/contact"
            target="_blank"
            rel="noopener noreferrer"
            className="faq-link"
          >
            our contact page
          </a>{" "}
          for guidance.
        </p>
      ),
    },
  ];

  return (
    <>
      <section className="faq-section py-5">
        <div className="container">
          {/* Title Section with Purple Bar */}
          <div
            className="d-flex align-items-center mb-5"
            style={{ marginLeft: "8%" }}
          >
            <div className="title-bar me-3"></div>
            <h2 className="fw-bold text-dark m-0">
              Frequently Asked Questions
            </h2>
          </div>

          {/* FAQ List */}
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              {faqData.map((item) => (
                <div
                  key={item.id}
                  className={`faq-item mb-3 ${
                    activeId === item.id ? "active" : ""
                  }`}
                  onClick={() => toggleFAQ(item.id)}
                >
                  {/* Question Header */}
                  <div className="faq-header d-flex justify-content-between align-items-center p-3 cursor-pointer">
                    <h6
                      className={`m-0 fw-semibold ${
                        activeId === item.id ? "text-purple" : "text-dark"
                      }`}
                    >
                      {item.question}
                    </h6>
                    <i
                      className={`bi bi-chevron-down transition-icon ${
                        activeId === item.id ? "rotate-180" : ""
                      }`}
                    ></i>
                  </div>

                  {/* Answer Body (Collapsible) */}
                  <div
                    className={`faq-body ${activeId === item.id ? "show" : ""}`}
                  >
                    <div className="p-3 pt-0 text-muted small lh-lg">
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

       <Banner/>

     
    </>
  );
};

export default FAQSection;
